export default __webpack_public_path__ + "static/hero-5-54779f71f53e39386f1b1ebd9432ecd8.avif";